import { useTheme } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { ChevronDown } from "react-feather";

export function BackButton({
  onClick,
  className,
  children,
}: Readonly<{ onClick?: () => void; className?: string; children: React.ReactNode }>) {
  const theme = useTheme();

  return (
    <IconButton
      size="large"
      aria-label="back-button"
      onClick={onClick}
      css={{ paddingLeft: 5, borderRadius: 100 }}
      className={className}
    >
      <ChevronDown
        css={{
          color: theme.palette.primary.main,
          transform: `rotateZ(90deg)`,
        }}
        size={16}
      />
      <Typography variant="body2" color="primary">
        {children}
      </Typography>
    </IconButton>
  );
}
